import PostTeaser from 'components/PostTeaser'

const Index = ({ posts, showType = true, firstLarge = false }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 lg:grid-cols-3 lg:gap-10">
      {posts &&
        !!posts.length &&
        posts.map((post, i) => (
          <PostTeaser
            key={post._id}
            post={post}
            showType={showType}
            large={firstLarge && i === 0 ? true : false}
          />
        ))}
    </div>
  )
}
export default Index
